// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/Thicker-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/fonts/Thicker-Medium.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: lightThicker;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

@font-face {
  font-family: mediumThicker;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.franchise_wrapper {
  width: 100%;
  position: relative;
}

.franchise_main_div {
  width: 100%;
  background-color: #fff !important;
}

.frnachise_info_main_div {
  max-width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.frnachise_info_div {
  width: 100%;
  padding: 0 80px;
}

.frnachise_info_p1 {
  color: #000;
  font-family: lightThicker;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 30px */
  margin-top: 30px;
}

.frnachise_info_p2 {
  color: #000;
  font-family: lightThicker;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 30px */
  margin: 10px 0 40px 0;
}

.frnachise_info_div > ul > li {
  color: #000;
  font-family: lightThicker;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}

.frnachise_info_div > ul > li::marker {
  color: #ba1e24;
}

.frnachise_info_div > ul {
  margin-left: 20px;
}

.frnachise_info_div > ul > li > span {
  color: #ba1e24;
  font-family: mediumThicker;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%; /* 30px */
}

.frnachise_info_p3 {
  color: #000;
  font-family: lightThicker;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 30px */
  margin: 50px 0;
}

/* franchise form  */

.franchise_form_main_div {
  max-width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.franchise_form_div {
  width: 100%;
  padding: 0 80px;
}

.franchise_form {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  /* justify-content: space-between; */
  gap: 20 !important;
}

.franchise_field_box {
  width: calc(33% - 10px);
  display: flex;
  flex-direction: column;
  margin: 0 0 25px 0;
}

.franchise_field_box > label {
  color: #000;
  font-family: lightThicker;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  margin-bottom: 4px;
  margin-left: 20px;

}

.franchise_field {
  height: 50px !important;
  flex-shrink: 0;
  padding: 0 17px;
  margin-left: 20px;
  border-radius: 4px;
  border: 1px solid #d2d3d4;
  color: #000103;
  font-family: lightThicker;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  letter-spacing: 0.25px;
  outline: none;
}

.franchise_text_area {
  width: 66%;
  display: flex;
  flex-direction: column;
  margin: 0 0 25px 0;
}

.franchise_text_area > label {
  color: #000;
  font-family: lightThicker;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  margin-bottom: 4px;
  margin-left: 20px;
}

.franchise_text_area_field {
  height: 152px !important;
  flex-shrink: 0;
  padding: 0 17px;
  margin-left: 20px;
  border-radius: 4px;
  border: 1px solid #d2d3d4;
  color: #000103;
  font-family: lightThicker;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  letter-spacing: 0.25px;
  outline: none;
  resize: none;
}

.franchise_invalid_feedback {
  color: #e42323;
  font-family: lightThicker;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0.25px;
  margin-top: 4px;
  margin-left: 20px;
}

.franchise_join_btn_div {
  display: flex;
  width: 180px;
  height: 54px;
  padding: 10px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  background: linear-gradient(0deg, #ba1e24 0%, #ba1e24 100%), #fff;
  color: #fff;
  font-family: lightThicker;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 126.6%;
  border: none;
  margin-bottom: 50px;
  margin-left: 20px;
}








@media screen and (max-width: 1200px) {
      
  .franchise_form_div {
    width: 100%;
    padding: 0 50px;
  }
  
  .franchise_form {
    /* justify-content: space-between; */
    gap: 20 !important;
  }
  
  .franchise_field_box {
    width: calc(33% - 10px);
    margin: 0 0 20px 0;
  }
  
  .franchise_field_box > label {
    font-size: 18px;
    margin-bottom: 4px;
  }
  
  .franchise_field {
    height: 50px !important;
    padding: 0 17px;
    font-size: 14px;
    line-height: 18px;
  }
  
  .franchise_text_area {
    width: 66%;
    margin: 0 0 20px 0;
  }
  
  .franchise_text_area > label {
    font-size: 18px;
    margin-bottom: 4px;
  }
  
  .franchise_text_area_field {
    height: 130px !important;
    padding: 0 17px;
    font-size: 14px;
    line-height: 18px;
  }
  
  .franchise_invalid_feedback {
    font-size: 14px;
    line-height: 18px;
    margin-top: 4px;
  }
  
  .franchise_join_btn_div {
    width: 150px;
    height: 45px;
    gap: 10px;
    font-size: 20px;
    margin-bottom: 60px;
  }    
  
  
  .frnachise_info_main_div {
        max-width: 100%;
      }
      
      .frnachise_info_div {
        width: 100%;
        padding: 0 50px;
      }
      
      .frnachise_info_p1 {
        font-size: 20px;
        margin-top: 30px;
      }
      
      .frnachise_info_p2 {
        font-size: 20px;
        margin: 10px 0 30px 0;
      }
      
      .frnachise_info_div > ul > li {
        font-size: 20px;
      }
      
      .frnachise_info_div > ul {
        margin-left: 20px;
      }
      
      .frnachise_info_div > ul > li > span {
        font-size: 20px;
      }
      
      .frnachise_info_p3 {
        font-size: 20px;
        margin: 40px 0 40px 0;
      }

}














@media screen and (max-width: 1024px) {
    
  .franchise_form_div {
    width: 100%;
    padding: 0 40px;
  }
  
  .franchise_form {
    justify-content: space-between;
    gap: 20 !important;
  }
  
  .franchise_field_box {
    width: calc(50% - 10px);
    margin: 0 0 20px 0;
  }
  
  .franchise_field_box > label {
    font-size: 18px;
    margin-bottom: 4px;
  }
  
  .franchise_field {
    height: 50px !important;
    padding: 0 17px;
    font-size: 14px;
    line-height: 18px;
  }
  
  .franchise_text_area {
    width: 100%;
    margin: 0 0 20px 0;
  }
  
  .franchise_text_area > label {
    font-size: 18px;
    margin-bottom: 4px;
  }
  
  .franchise_text_area_field {
    height: 130px !important;
    padding: 12px 17px;
    font-size: 14px;
    line-height: 18px;
  }
  
  .franchise_invalid_feedback {
    font-size: 14px;
    line-height: 18px;
    margin-top: 4px;
  }
  
  .franchise_join_btn_div {
    width: 150px;
    height: 45px;
    gap: 10px;
    font-size: 20px;
    margin-bottom: 60px;
  }

  
  .frnachise_info_main_div {
      max-width: 100%;
    }
    
    .frnachise_info_div {
      width: 100%;
      padding: 0 40px;
    }
    
    .frnachise_info_p1 {
      font-size: 20px;
      margin-top: 30px;
    }
    
    .frnachise_info_p2 {
      font-size: 20px;
      margin: 10px 0 30px 0;
    }
    
    .frnachise_info_div > ul > li {
      font-size: 20px;
    }
    
    .frnachise_info_div > ul {
      margin-left: 20px;
    }
    
    .frnachise_info_div > ul > li > span {
      font-size: 20px;
    }
    
    .frnachise_info_p3 {
      font-size: 20px;
      margin: 40px 0 40px 0;
    }

}















@media screen and (max-width: 800px) {
    
    .frnachise_info_main_div {
      max-width: 100%;
    }
    
    .frnachise_info_div {
      width: 100%;
      padding: 0 30px;
    }
    
    .frnachise_info_p1 {
      font-size: 20px;
      margin-top: 30px;
    }
    
    .frnachise_info_p2 {
      font-size: 20px;
      margin: 10px 0 30px 0;
    }
    
    .frnachise_info_div > ul > li {
      font-size: 20px;
    }
    
    .frnachise_info_div > ul {
      margin-left: 20px;
    }
    
    .frnachise_info_div > ul > li > span {
      font-size: 20px;
    }
    
    .frnachise_info_p3 {
      font-size: 20px;
      margin: 40px 0 40px 0;
    }

}













@media screen and (max-width: 600px) {
    
  .franchise_form_div {
    width: 100%;
    padding: 0 20px 0px 0px;  }
  
  .franchise_form {
    justify-content: space-between;
    gap: 10 !important;
  }
  
  .franchise_field_box {
    width: 100%;
    margin: 0 0 16px 0;
  }
  
  .franchise_field_box > label {
    font-size: 16px;
    margin-bottom: 2px;
  }
  
  .franchise_field {
    height: 45px !important;
    padding: 0 10px;
    font-size: 14px;
    line-height: 18px;
  }
  
  .franchise_text_area {
    width: 100%;
    margin: 0 0 12px 0;
  }
  
  .franchise_text_area > label {
    font-size: 16px;
    margin-bottom: 2px;
  }
  
  .franchise_text_area_field {
    height: 120px !important;
    padding: 10px 10px;
    font-size: 14px;
    line-height: 18px;
  }
  
  .franchise_invalid_feedback {
    font-size: 14px;
    line-height: 18px;
    margin-top: 4px;
  }
  
  .franchise_join_btn_div {
    width: 140px;
    height: 42px;
    gap: 10px;
    font-size: 18px;
    margin-bottom: 60px;
  }  
  
  .frnachise_info_main_div {
      max-width: 100%;
    }
    
    .frnachise_info_div {
      width: 100%;
      padding: 0 20px;
    }
    
    .frnachise_info_p1 {
     font-size: 16px;
      line-height: 22px;
      margin-top: 20px;
    }
    
    .frnachise_info_p2 {
     font-size: 16px;
      line-height: 22px;
      margin: 10px 0 20px 0;
    }
    
    .frnachise_info_div > ul > li {
     font-size: 16px;
      line-height: 22px;
    }
    
    .frnachise_info_div > ul {
      margin-left: 20px;
    }
    
    .frnachise_info_div > ul > li > span {
      font-size: 16px;
    }
    
    .frnachise_info_p3 {
        font-size: 16px;
        line-height: 22px;
      margin: 30px 0 30px 0;
    }

}












@media screen and (max-width: 450px) {
    
    .frnachise_info_main_div {
      max-width: 100%;
    }
    
    .frnachise_info_div {
      width: 100%;
      padding: 0 16px;
    }
    
    .frnachise_info_p1 {
     font-size: 16px;
      line-height: 22px;
      margin-top: 20px;
    }
    
    .frnachise_info_p2 {
     font-size: 16px;
      line-height: 22px;
      margin: 10px 0 20px 0;
    }
    
    .frnachise_info_div > ul > li {
     font-size: 16px;
      line-height: 22px;
    }
    
    .frnachise_info_div > ul {
      margin-left: 0px !important;
    }
    
    .frnachise_info_div > ul > li > span {
      font-size: 16px;
    }
    
    .frnachise_info_p3 {
        font-size: 16px;
        line-height: 22px;
      margin: 20px 0 20px 0;
    }

}`, "",{"version":3,"sources":["webpack://./src/components/franchise/franchise.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,4CAAgD;AAClD;;AAEA;EACE,0BAA0B;EAC1B,4CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;AAC9B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,cAAc;AAChB;;AAEA,oBAAoB;;AAEpB;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;;AAEnB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,iEAAiE;EACjE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;AACnB;;;;;;;;;AASA;;EAEE;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,oCAAoC;IACpC,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,eAAe;IACf,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,wBAAwB;IACxB,eAAe;IACf,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,SAAS;IACT,eAAe;IACf,mBAAmB;EACrB;;;EAGA;QACM,eAAe;MACjB;;MAEA;QACE,WAAW;QACX,eAAe;MACjB;;MAEA;QACE,eAAe;QACf,gBAAgB;MAClB;;MAEA;QACE,eAAe;QACf,qBAAqB;MACvB;;MAEA;QACE,eAAe;MACjB;;MAEA;QACE,iBAAiB;MACnB;;MAEA;QACE,eAAe;MACjB;;MAEA;QACE,eAAe;QACf,qBAAqB;MACvB;;AAEN;;;;;;;;;;;;;;;AAeA;;EAEE;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,8BAA8B;IAC9B,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,eAAe;IACf,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,wBAAwB;IACxB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,SAAS;IACT,eAAe;IACf,mBAAmB;EACrB;;;EAGA;MACI,eAAe;IACjB;;IAEA;MACE,WAAW;MACX,eAAe;IACjB;;IAEA;MACE,eAAe;MACf,gBAAgB;IAClB;;IAEA;MACE,eAAe;MACf,qBAAqB;IACvB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;MACf,qBAAqB;IACvB;;AAEJ;;;;;;;;;;;;;;;;AAgBA;;IAEI;MACE,eAAe;IACjB;;IAEA;MACE,WAAW;MACX,eAAe;IACjB;;IAEA;MACE,eAAe;MACf,gBAAgB;IAClB;;IAEA;MACE,eAAe;MACf,qBAAqB;IACvB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;MACf,qBAAqB;IACvB;;AAEJ;;;;;;;;;;;;;;AAcA;;EAEE;IACE,WAAW;IACX,uBAAuB,GAAG;;EAE5B;IACE,8BAA8B;IAC9B,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,eAAe;IACf,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,wBAAwB;IACxB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,SAAS;IACT,eAAe;IACf,mBAAmB;EACrB;;EAEA;MACI,eAAe;IACjB;;IAEA;MACE,WAAW;MACX,eAAe;IACjB;;IAEA;KACC,eAAe;MACd,iBAAiB;MACjB,gBAAgB;IAClB;;IAEA;KACC,eAAe;MACd,iBAAiB;MACjB,qBAAqB;IACvB;;IAEA;KACC,eAAe;MACd,iBAAiB;IACnB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,eAAe;IACjB;;IAEA;QACI,eAAe;QACf,iBAAiB;MACnB,qBAAqB;IACvB;;AAEJ;;;;;;;;;;;;;AAaA;;IAEI;MACE,eAAe;IACjB;;IAEA;MACE,WAAW;MACX,eAAe;IACjB;;IAEA;KACC,eAAe;MACd,iBAAiB;MACjB,gBAAgB;IAClB;;IAEA;KACC,eAAe;MACd,iBAAiB;MACjB,qBAAqB;IACvB;;IAEA;KACC,eAAe;MACd,iBAAiB;IACnB;;IAEA;MACE,2BAA2B;IAC7B;;IAEA;MACE,eAAe;IACjB;;IAEA;QACI,eAAe;QACf,iBAAiB;MACnB,qBAAqB;IACvB;;AAEJ","sourcesContent":["@font-face {\n  font-family: lightThicker;\n  src: url(../../assets/fonts/Thicker-Regular.otf);\n}\n\n@font-face {\n  font-family: mediumThicker;\n  src: url(../../assets/fonts/Thicker-Medium.otf);\n}\n\n.franchise_wrapper {\n  width: 100%;\n  position: relative;\n}\n\n.franchise_main_div {\n  width: 100%;\n  background-color: #fff !important;\n}\n\n.frnachise_info_main_div {\n  max-width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.frnachise_info_div {\n  width: 100%;\n  padding: 0 80px;\n}\n\n.frnachise_info_p1 {\n  color: #000;\n  font-family: lightThicker;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%; /* 30px */\n  margin-top: 30px;\n}\n\n.frnachise_info_p2 {\n  color: #000;\n  font-family: lightThicker;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%; /* 30px */\n  margin: 10px 0 40px 0;\n}\n\n.frnachise_info_div > ul > li {\n  color: #000;\n  font-family: lightThicker;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%;\n}\n\n.frnachise_info_div > ul > li::marker {\n  color: #ba1e24;\n}\n\n.frnachise_info_div > ul {\n  margin-left: 20px;\n}\n\n.frnachise_info_div > ul > li > span {\n  color: #ba1e24;\n  font-family: mediumThicker;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 150%; /* 30px */\n}\n\n.frnachise_info_p3 {\n  color: #000;\n  font-family: lightThicker;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%; /* 30px */\n  margin: 50px 0;\n}\n\n/* franchise form  */\n\n.franchise_form_main_div {\n  max-width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.franchise_form_div {\n  width: 100%;\n  padding: 0 80px;\n}\n\n.franchise_form {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  /* justify-content: space-between; */\n  gap: 20 !important;\n}\n\n.franchise_field_box {\n  width: calc(33% - 10px);\n  display: flex;\n  flex-direction: column;\n  margin: 0 0 25px 0;\n}\n\n.franchise_field_box > label {\n  color: #000;\n  font-family: lightThicker;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%;\n  margin-bottom: 4px;\n  margin-left: 20px;\n\n}\n\n.franchise_field {\n  height: 50px !important;\n  flex-shrink: 0;\n  padding: 0 17px;\n  margin-left: 20px;\n  border-radius: 4px;\n  border: 1px solid #d2d3d4;\n  color: #000103;\n  font-family: lightThicker;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 28px;\n  letter-spacing: 0.25px;\n  outline: none;\n}\n\n.franchise_text_area {\n  width: 66%;\n  display: flex;\n  flex-direction: column;\n  margin: 0 0 25px 0;\n}\n\n.franchise_text_area > label {\n  color: #000;\n  font-family: lightThicker;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%;\n  margin-bottom: 4px;\n  margin-left: 20px;\n}\n\n.franchise_text_area_field {\n  height: 152px !important;\n  flex-shrink: 0;\n  padding: 0 17px;\n  margin-left: 20px;\n  border-radius: 4px;\n  border: 1px solid #d2d3d4;\n  color: #000103;\n  font-family: lightThicker;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 28px;\n  letter-spacing: 0.25px;\n  outline: none;\n  resize: none;\n}\n\n.franchise_invalid_feedback {\n  color: #e42323;\n  font-family: lightThicker;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n  letter-spacing: 0.25px;\n  margin-top: 4px;\n  margin-left: 20px;\n}\n\n.franchise_join_btn_div {\n  display: flex;\n  width: 180px;\n  height: 54px;\n  padding: 10px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n  background: linear-gradient(0deg, #ba1e24 0%, #ba1e24 100%), #fff;\n  color: #fff;\n  font-family: lightThicker;\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 126.6%;\n  border: none;\n  margin-bottom: 50px;\n  margin-left: 20px;\n}\n\n\n\n\n\n\n\n\n@media screen and (max-width: 1200px) {\n      \n  .franchise_form_div {\n    width: 100%;\n    padding: 0 50px;\n  }\n  \n  .franchise_form {\n    /* justify-content: space-between; */\n    gap: 20 !important;\n  }\n  \n  .franchise_field_box {\n    width: calc(33% - 10px);\n    margin: 0 0 20px 0;\n  }\n  \n  .franchise_field_box > label {\n    font-size: 18px;\n    margin-bottom: 4px;\n  }\n  \n  .franchise_field {\n    height: 50px !important;\n    padding: 0 17px;\n    font-size: 14px;\n    line-height: 18px;\n  }\n  \n  .franchise_text_area {\n    width: 66%;\n    margin: 0 0 20px 0;\n  }\n  \n  .franchise_text_area > label {\n    font-size: 18px;\n    margin-bottom: 4px;\n  }\n  \n  .franchise_text_area_field {\n    height: 130px !important;\n    padding: 0 17px;\n    font-size: 14px;\n    line-height: 18px;\n  }\n  \n  .franchise_invalid_feedback {\n    font-size: 14px;\n    line-height: 18px;\n    margin-top: 4px;\n  }\n  \n  .franchise_join_btn_div {\n    width: 150px;\n    height: 45px;\n    gap: 10px;\n    font-size: 20px;\n    margin-bottom: 60px;\n  }    \n  \n  \n  .frnachise_info_main_div {\n        max-width: 100%;\n      }\n      \n      .frnachise_info_div {\n        width: 100%;\n        padding: 0 50px;\n      }\n      \n      .frnachise_info_p1 {\n        font-size: 20px;\n        margin-top: 30px;\n      }\n      \n      .frnachise_info_p2 {\n        font-size: 20px;\n        margin: 10px 0 30px 0;\n      }\n      \n      .frnachise_info_div > ul > li {\n        font-size: 20px;\n      }\n      \n      .frnachise_info_div > ul {\n        margin-left: 20px;\n      }\n      \n      .frnachise_info_div > ul > li > span {\n        font-size: 20px;\n      }\n      \n      .frnachise_info_p3 {\n        font-size: 20px;\n        margin: 40px 0 40px 0;\n      }\n\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n@media screen and (max-width: 1024px) {\n    \n  .franchise_form_div {\n    width: 100%;\n    padding: 0 40px;\n  }\n  \n  .franchise_form {\n    justify-content: space-between;\n    gap: 20 !important;\n  }\n  \n  .franchise_field_box {\n    width: calc(50% - 10px);\n    margin: 0 0 20px 0;\n  }\n  \n  .franchise_field_box > label {\n    font-size: 18px;\n    margin-bottom: 4px;\n  }\n  \n  .franchise_field {\n    height: 50px !important;\n    padding: 0 17px;\n    font-size: 14px;\n    line-height: 18px;\n  }\n  \n  .franchise_text_area {\n    width: 100%;\n    margin: 0 0 20px 0;\n  }\n  \n  .franchise_text_area > label {\n    font-size: 18px;\n    margin-bottom: 4px;\n  }\n  \n  .franchise_text_area_field {\n    height: 130px !important;\n    padding: 12px 17px;\n    font-size: 14px;\n    line-height: 18px;\n  }\n  \n  .franchise_invalid_feedback {\n    font-size: 14px;\n    line-height: 18px;\n    margin-top: 4px;\n  }\n  \n  .franchise_join_btn_div {\n    width: 150px;\n    height: 45px;\n    gap: 10px;\n    font-size: 20px;\n    margin-bottom: 60px;\n  }\n\n  \n  .frnachise_info_main_div {\n      max-width: 100%;\n    }\n    \n    .frnachise_info_div {\n      width: 100%;\n      padding: 0 40px;\n    }\n    \n    .frnachise_info_p1 {\n      font-size: 20px;\n      margin-top: 30px;\n    }\n    \n    .frnachise_info_p2 {\n      font-size: 20px;\n      margin: 10px 0 30px 0;\n    }\n    \n    .frnachise_info_div > ul > li {\n      font-size: 20px;\n    }\n    \n    .frnachise_info_div > ul {\n      margin-left: 20px;\n    }\n    \n    .frnachise_info_div > ul > li > span {\n      font-size: 20px;\n    }\n    \n    .frnachise_info_p3 {\n      font-size: 20px;\n      margin: 40px 0 40px 0;\n    }\n\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n@media screen and (max-width: 800px) {\n    \n    .frnachise_info_main_div {\n      max-width: 100%;\n    }\n    \n    .frnachise_info_div {\n      width: 100%;\n      padding: 0 30px;\n    }\n    \n    .frnachise_info_p1 {\n      font-size: 20px;\n      margin-top: 30px;\n    }\n    \n    .frnachise_info_p2 {\n      font-size: 20px;\n      margin: 10px 0 30px 0;\n    }\n    \n    .frnachise_info_div > ul > li {\n      font-size: 20px;\n    }\n    \n    .frnachise_info_div > ul {\n      margin-left: 20px;\n    }\n    \n    .frnachise_info_div > ul > li > span {\n      font-size: 20px;\n    }\n    \n    .frnachise_info_p3 {\n      font-size: 20px;\n      margin: 40px 0 40px 0;\n    }\n\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n@media screen and (max-width: 600px) {\n    \n  .franchise_form_div {\n    width: 100%;\n    padding: 0 20px 0px 0px;  }\n  \n  .franchise_form {\n    justify-content: space-between;\n    gap: 10 !important;\n  }\n  \n  .franchise_field_box {\n    width: 100%;\n    margin: 0 0 16px 0;\n  }\n  \n  .franchise_field_box > label {\n    font-size: 16px;\n    margin-bottom: 2px;\n  }\n  \n  .franchise_field {\n    height: 45px !important;\n    padding: 0 10px;\n    font-size: 14px;\n    line-height: 18px;\n  }\n  \n  .franchise_text_area {\n    width: 100%;\n    margin: 0 0 12px 0;\n  }\n  \n  .franchise_text_area > label {\n    font-size: 16px;\n    margin-bottom: 2px;\n  }\n  \n  .franchise_text_area_field {\n    height: 120px !important;\n    padding: 10px 10px;\n    font-size: 14px;\n    line-height: 18px;\n  }\n  \n  .franchise_invalid_feedback {\n    font-size: 14px;\n    line-height: 18px;\n    margin-top: 4px;\n  }\n  \n  .franchise_join_btn_div {\n    width: 140px;\n    height: 42px;\n    gap: 10px;\n    font-size: 18px;\n    margin-bottom: 60px;\n  }  \n  \n  .frnachise_info_main_div {\n      max-width: 100%;\n    }\n    \n    .frnachise_info_div {\n      width: 100%;\n      padding: 0 20px;\n    }\n    \n    .frnachise_info_p1 {\n     font-size: 16px;\n      line-height: 22px;\n      margin-top: 20px;\n    }\n    \n    .frnachise_info_p2 {\n     font-size: 16px;\n      line-height: 22px;\n      margin: 10px 0 20px 0;\n    }\n    \n    .frnachise_info_div > ul > li {\n     font-size: 16px;\n      line-height: 22px;\n    }\n    \n    .frnachise_info_div > ul {\n      margin-left: 20px;\n    }\n    \n    .frnachise_info_div > ul > li > span {\n      font-size: 16px;\n    }\n    \n    .frnachise_info_p3 {\n        font-size: 16px;\n        line-height: 22px;\n      margin: 30px 0 30px 0;\n    }\n\n}\n\n\n\n\n\n\n\n\n\n\n\n\n@media screen and (max-width: 450px) {\n    \n    .frnachise_info_main_div {\n      max-width: 100%;\n    }\n    \n    .frnachise_info_div {\n      width: 100%;\n      padding: 0 16px;\n    }\n    \n    .frnachise_info_p1 {\n     font-size: 16px;\n      line-height: 22px;\n      margin-top: 20px;\n    }\n    \n    .frnachise_info_p2 {\n     font-size: 16px;\n      line-height: 22px;\n      margin: 10px 0 20px 0;\n    }\n    \n    .frnachise_info_div > ul > li {\n     font-size: 16px;\n      line-height: 22px;\n    }\n    \n    .frnachise_info_div > ul {\n      margin-left: 0px !important;\n    }\n    \n    .frnachise_info_div > ul > li > span {\n      font-size: 16px;\n    }\n    \n    .frnachise_info_p3 {\n        font-size: 16px;\n        line-height: 22px;\n      margin: 20px 0 20px 0;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
